import { _ as __rest, a as __assign } from './tslib.es6-01f7d394.js';
import * as React from 'react';

var CheckIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M23.181 4.914l-14.2 16c-.4.4-1.1.5-1.5 0l-7.2-7.6c-.3-.4-.4-.9-.1-1.3l1-1.2c.3-.4.8-.5 1.2-.3l5.3 2.6 12.8-10.9c.4-.3 1-.3 1.4.1l1.2 1.2c.4.4.4 1 .1 1.4z", fill: fillColor, fillRule: "evenodd" })));
};

export { CheckIcon as C };
